import { Badge, type BadgeProps } from "@chakra-ui/react";

type Props = BadgeProps;

export function BadgeStyled(props: Props) {
  const { children } = props;

  return (
    <Badge
      borderRadius="50px"
      height="1.25rem"
      minWidth="1.25rem"
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      {...props}
    >
      {children}
    </Badge>
  );
}
